import React from 'react';
export function AnimatedFlagBackground() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-white" data-id="element-1">
      <div className="absolute inset-0 opacity-[0.55] w-[115%] h-[115%] -left-[7%] -top-[7%] animate-gentle-wave will-change-transform" data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/pxNyUodXi4zr45tGRxAkVR/KATE_4Landingpage_1.png" alt="" role="presentation" className="w-full h-full object-cover object-center" loading="eager" decoding="async" data-id="element-3" />
      </div>
      <div className="absolute inset-0 bg-white/30" data-id="element-4"></div>
    </div>;
}